"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTicketMatchingSearchTerm = void 0;
const isTicketMatchingSearchTerm = (t, searchTermString) => {
    if (!searchTermString)
        return true;
    const searchTerm = searchTermString.toLowerCase();
    const result = (t.order.display_id.toString().toLowerCase().includes(searchTerm) ||
        t.order.customer?.first_name
            ?.toString()
            .toLowerCase()
            .includes(searchTerm) ||
        t.order.customer?.last_name
            ?.toString()
            .toLowerCase()
            .includes(searchTerm) ||
        t.seatAllocation?.seatNumber
            ?.toString()
            .toLowerCase()
            .includes(searchTerm) ||
        t.order.email?.toLowerCase().includes(searchTerm) ||
        t.id?.slice(-4).toLowerCase().includes(searchTerm));
    if (result === undefined) {
        return false;
    }
    else { }
    return result;
};
exports.isTicketMatchingSearchTerm = isTicketMatchingSearchTerm;
//# sourceMappingURL=search-tickets.js.map